import React from "react"
import { defaultMarkdownElements } from "@internal/ui"
import type { UnorderedListNode } from "../renderer/types"
import { ContentList } from "./content-item"

export function UnorderedListContent({ content }: { content: UnorderedListNode }) {
  return (
    <defaultMarkdownElements.ul.component {...defaultMarkdownElements.ul.props}>
      <ContentList contents={content.content} asList />
    </defaultMarkdownElements.ul.component>
  )
}
